import PropTypes from "prop-types";
import Modal from "../../boxes/Modal";
import { withRouter } from "react-router-dom";
import { features } from '../../../services/constants';
import { careBalanceLearnMoreUrl } from '../constants/careBalanceLearnMoreUrl';

const checkSuccess = "/img/care-balance/check-success.svg";
const infoCircleBlue = "/img/care-balance/info-circle-blue.svg";
const wallet = "/img/care-balance/wallet.svg";
const creditCard = "/img/care-balance/credit-card.svg";
const moneyWavy = "/img/care-balance/money-wavy.svg";

const commonBottomStyle = {
  paddingBlock: "11.5px",
  paddingInline: "12px",
  flex: 1,
  borderRadius: "4px",
  fontSize: "1.744rem",
  lineHeight: "100%",
  letterSpacing: "0%",
  fontWeight: 700,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};

const CareBalanceCard = ({ title, children }) => {
  return (
    <div
      style={{
        borderRadius: "12px",
        backgroundColor: "#F0F8FF",
        padding: "16px",
        width: "100%",
        display: "flex",
        columnGap: "8px",
        alignItems: "flex-start",
      }}
    >
      <img
        src={infoCircleBlue}
        style={{
          width: "24px",
          height: "24px",
        }}
      />

      <div>
        <h4
          style={{
            color: "#0D5889",
            fontWeight: 500,
            fontSize: "1.4rem",
            lineHeight: "24px",
            letterSpacing: "0%",
          }}
        >
          {title}
        </h4>

        <p
          style={{
            fontSize: "1.4rem",
            color: "#137CC1",
            lineHeight: "20px",
            letterSpacing: "0px",
          }}
        >
          {children}
        </p>
      </div>
    </div>
  );
};

const CareBalanceModal = ({ onClose, t, history }) => {
  const benefits = [
    {
      title: t("fundModalFirstBenefitTitle"),
      subtitle: t("fundModalFirstBenefitSubtitle"),
    },
    {
      title: t("fundModalSecondBenefitTitle"),
      subtitle: t("fundModalSecondBenefitSubtitle"),
    },
    {
      title: "",
      subtitle: t("fundModalThirdBenefitSubtitle"),
    },
  ];

  const steps = [
    {
      icon: wallet,
      title: t("fundModalFirstStepTitle"),
    },
    {
      icon: creditCard,
      title: t("fundModalSecondStepTitle"),
    },
    {
      icon: moneyWavy,
      title: t("fundModalThirdStepTitle"),
    },
  ];

  return (
    <Modal
      title={t("fundModalTitle")}
      onClose={onClose}
      style={{
        fontWeight: 700,
        color: "#212121",
        fontSize: "2.4rem",
        alignSelf: "flex-start",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          justifyContent: "flex-start",
          rowGap: "16px",
          maxWidth: "560px",
        }}
      >
        <p
          style={{
            fontSize: "1.688rem",
            lineHeight: "100%",
            letterSpacing: "0%",

            color: "#000000",
          }}
        >
          {t("fundModalDescription")}{" "}
          <a
            target='_blank'
            href={careBalanceLearnMoreUrl}
            style={{
              color: "#107BC0",
              textDecoration: "underline",
            }}
          >
            {t("learnMore")}
          </a>
        </p>

        <ul>
          {benefits.map((benefit) => (
            <li
              style={{
                display: "flex",
                alignItems: "center",
                columnGap: "8px",
                paddingBlock: "4px",
              }}
              key={benefit.title + benefit.subtitle}
            >
              <img
                src={checkSuccess}
                style={{
                  width: "19.2px",
                  height: "19.2px",
                }}
              />

              <p
                style={{
                  fontSize: "1.4rem",
                  lineHeight: "22px",
                  letterSpacing: "0%",
                  color: "#1C1B1B",
                }}
              >
                {benefit.title && <strong>{benefit.title} </strong>}
                {benefit.subtitle}
              </p>
            </li>
          ))}
        </ul>

        <CareBalanceCard title={t("fundModalFirstInfoTitle")}>
          {t("fundModalFirstInfoSubtitle1")} <br />
          {t("fundModalFirstInfoSubtitle2")}
        </CareBalanceCard>

        <CareBalanceCard title={t("fundModalSecondInfoTitle")}>
          {t("fundModalSecondInfoSubtitle")} <br />
          <a
            href="#"
            onClick={(e) => {
              e.preventDefault();
              history.push("/request-refund");
            }}
            style={{
              color: "#137CC1",
              fontWeight: 500,
              lineHeight: "100%",
              letterSpacing: "0%",
              textDecoration: "underline",
              paddingTop: "8px",
              display: "inline-block",
            }}
          >
            {t("requestRefundInfoLink")}
          </a>
        </CareBalanceCard>

        <div
          style={{
            width: "100%",
          }}
        >
          <h4
            style={{
              fontWeight: 700,
              color: "#212121",
              fontSize: "2.4rem",
              lineHeight: "100%",
              letterSpacing: "0%",
              marginBottom: "4px",
            }}
          >
            {t("fundModalStepsTitle")}
          </h4>

          <div
            style={{
              borderRadius: "16px",
              border: "1px solid #DDDEDF",
              paddingBlock: "8px",
              paddingInline: "16px",
            }}
          >
            {steps.map((step, index) => (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  columnGap: "8px",
                  paddingBlock: "8px",
                  ...(index === steps.length - 1
                    ? {}
                    : {
                        borderBottom: "1px solid #dddedf",
                      }),
                }}
              >
                <div
                  style={{
                    borderRadius: "50%",
                    padding: "8px",
                    backgroundColor: "#F2F2F2",
                    height: "40px",
                    width: "40px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <img
                    src={step.icon}
                    style={{
                      width: "20px",
                      height: "20px",
                    }}
                  />
                </div>

                <p
                  style={{
                    fontSize: "1.4rem",
                    lineHeight: "22px",
                    letterSpacing: "0%",
                    color: "#1C1B1B",
                    flex: 1,
                  }}
                >
                  {step.title}
                </p>
              </div>
            ))}
          </div>
        </div>

        <div
          style={{
            display: "flex",
            columnGap: "8px",
            width: "100%",
          }}
        >
          <button
            style={{
              ...commonBottomStyle,
              backgroundColor: "#094063",
              color: "#ffffff",
            }}
            onClick={() => history.push("/fund-care-balance")}
            data-testid="fund-care-balance-button"
          >
            {t("fundModalConfirmButtonLabel")}
          </button>

          <button
            style={{
              ...commonBottomStyle,
              color: "#094063",
              border: "1px solid #094063",
            }}
            onClick={onClose}
          >
            {t("fundModalCancelButtonLabel")}
          </button>
        </div>
      </div>
    </Modal>
  );
};

CareBalanceModal.propTypes = {
  onClose: PropTypes.func,
};

export default withRouter(CareBalanceModal);
